export * from "/codebuild/output/src1535834765/src/dgbet/local_modules/wallet/index.ts"